import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c316930a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-box-header d-flex justify-end align-center" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white pb-5"
}
const _hoisted_3 = { class: "pa-4" }
const _hoisted_4 = { class: "uploading-item mb-4" }
const _hoisted_5 = { class: "text-info" }
const _hoisted_6 = { class: "text-skillsText mb-2" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "d-flex flex-column align-end fill-height justify-center" }
const _hoisted_9 = { class: "upload-errors px-4 py-2" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "text-caption text-skillsText" }

import { ref, computed } from 'vue';
import { useCvUploadStore } from '@/store/cvUploads';


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadBox',
  setup(__props) {

const closed = ref(false);
const cvStore = useCvUploadStore();

const erroredFiles = computed({
    get() {
        return cvStore.erroredFiles;
    },
    set() {
        return;
    },
});

function reduce() {
    cvStore.collapsed = !cvStore.collapsed;
}

function close() {
    closed.value = true;
}

function stopUpload() {
    cvStore.stopUpload = true;
}

function undoUpload() {
    cvStore.undoUpload = true;
    cvStore.cancelUpload();
}

function playUpload() {
    cvStore.uploadCv();
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (!closed.value)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "upload-box"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  onClick: reduce,
                  class: "mr-2",
                  size: "large",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(cvStore).collapsed ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_icon, {
                  onClick: close,
                  class: "mr-4",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              (!_unref(cvStore).collapsed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "10" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_5, _toDisplayString(!_unref(cvStore).uploadFinished
                                            ? _ctx.$t('uploading')
                                            : _ctx.$t('upload_completed')), 1),
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(cvStore).percentage.toFixed(2)) + "% " + _toDisplayString(_unref(cvStore).time > 0
                                            ? ' | ' + _unref(cvStore).time.toFixed(0)
                                            : '') + " " + _toDisplayString(' ') + " " + _toDisplayString(_unref(cvStore).time > 0 ? _ctx.$t('seconds') : '') + " " + _toDisplayString(' ') + " " + _toDisplayString(_unref(cvStore).time > 0 ? _ctx.$t('to_finish') : ''), 1),
                                _createVNode(_component_v_progress_linear, {
                                  color: "info",
                                  modelValue: _unref(cvStore).percentage,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(cvStore).percentage) = $event)),
                                  "buffer-value": 100
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (!_unref(cvStore).uploadFinished)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "2"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_7, [
                                      (!_unref(cvStore).stopUpload)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            icon: "",
                                            color: "pauseButton",
                                            class: "mr-2",
                                            elevation: "0",
                                            size: "x-small",
                                            onClick: stopUpload
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                color: "pauseIcon",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" mdi-pause ")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            icon: "",
                                            color: "pauseButton",
                                            class: "mr-2",
                                            elevation: "0",
                                            size: "x-small",
                                            onClick: playUpload
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                color: "pauseIcon",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" mdi-play ")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })),
                                      _createVNode(_component_v_btn, {
                                        icon: "",
                                        size: "x-small",
                                        elevation: "0",
                                        color: "cancelButton",
                                        onClick: undoUpload
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            color: "red",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" mdi-close ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "2"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_v_btn, {
                                        icon: "",
                                        size: "x-small",
                                        elevation: "0",
                                        color: "cancelButton"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            color: "primary",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" mdi-check ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_v_divider),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(erroredFiles.value, (file, j) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: j,
                          class: "d-flex align-center justify-space-between"
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_v_icon, {
                              class: "mr-2",
                              color: "red",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" mdi-file-document-outline ")
                              ]),
                              _: 1
                            }),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(file.fileName), 1)
                          ]),
                          _createVNode(_component_v_icon, {
                            class: "ml-2",
                            color: "red",
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-alert")
                            ]),
                            _: 1
                          })
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})